import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, AuthRedirectComponent, ReleasenotesComponent } from 'quangular';
import { ErrorScreenComponent } from './modules/chat/pages/chat/components/error-screen/error-screen.component';
import { UnauthorizedComponent } from './modules/chat/pages/chat/components/unauthorized/unauthorized.component';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';

// The order of route configuration is important because the router accepts the first route that matches a navigation request path.
// ReleasenotesComponent has default('') path resolution and has to be included after the app defaults
const routes: Routes = [
    {
        path: 'auth',
        component: AuthRedirectComponent,
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
    },
    {
        path: 'admin',
        loadChildren: () =>
            import('./modules/admin/admin.module').then((m) => m.AdminModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'error',
        component: ErrorScreenComponent,
    },
    {
        path: 'releasenotes',
        component: ReleasenotesComponent,
    },
    {
        path: '',
        redirectTo: 'chat',
        pathMatch: 'full',
    },
    {
        path: '**',
        component: PageNotFoundComponent
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
